// Responsible for updating spreadsheet 
// only visible to supertokens team
import * as React from "react"
import Cookies from "js-cookie";
import {Navbar} from '../../components/sections';
import Footer from "../../footer";
import "./../../style/spreadsheet.module.css"
import {Button} from '../../components/elements'
import {updateSeoContent} from  './../../api/seo-content'
import { IMAGE_PATH_PREFIX, } from './../../constants';
import {LoadingFullScreenTransparent} from "./../../components/sections"
import { getCurrentUserId } from "../../utils";
const basePath = '/static/assets/';
const logoDesktop = IMAGE_PATH_PREFIX + basePath + "seo/spreadsheet_team.png";
type Props = {
};

type State = {
    userId: string,
    error: boolean, 
    toUpdate: string,
    loading: boolean,
    errorMessage: string,
    sucesssMessage:string
}

export default class SeoContent extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            userId: "",
            error: false,
            errorMessage: '',
            sucesssMessage: '',
            toUpdate: ''
        }
    }

    componentDidMount () {
        this.fetchAnalyticsUserId()
    }

    componentDidUpdate() {
        if (this.state.userId !== 'st-team-udid1234') {
            window.location.href = "/";
        }
    }

    fetchAnalyticsUserId = async () => {
        try {
            const userId = await getCurrentUserId()
            if (userId.length > 0) {
                this.setState({userId})
            } 
        } catch (error) {
            this.setState({userId: "missing_userId"})    
        }
    }

    onfileSelected = (event: React.ChangeEvent<HTMLSelectElement>) => {
        let value = event.target.value;
        this.setState({
          ...this.state, 
          toUpdate: value,
          error: false,
          errorMessage: '',
          sucesssMessage: ''
        })
    }

    onsubmit = async () => {
        this.setState({loading: true, errorMessage: '', sucesssMessage: ''})
        if (this.state.toUpdate === '') {
            this.setState({loading: false, sucesssMessage:'', error: true, errorMessage: 'Please select both environment and file to update'})
            return
        }
        const body = {
            supertokensId: this.state.userId,
            toUpdate: this.state.toUpdate
        }
        try {
            await updateSeoContent(body)
            this.setState({sucesssMessage: `Sucessfully updated`, loading: false})
        } catch (error) {
            this.setState({error: true, errorMessage: 'something went wrong', loading: false})
        }
    }

    render () {
        const {userId, errorMessage, error, sucesssMessage} = this.state
        if (userId === 'st-team-udid1234') {
            return (
                <div className="seocontent-main">
                    <LoadingFullScreenTransparent
                    loading={this.state.loading}
                    />
                <Navbar />
                <div className="spreadsheet-main center-horizontally">
                    <div className="spreadsheet-image">
                        <img src={logoDesktop} />
                    </div>
                    <h3 className="text-center spreadsheet-heading"> Supertokens team members can update digital content from here</h3>
                    {error && errorMessage ?  <h5 className="text-center spreadsheet-heading-error">{errorMessage}</h5> : null }
                    {sucesssMessage ?  <h5 className="text-center spreadsheet-heading-sucess">{sucesssMessage}</h5> : null }
                <div>
                <div className="spreadsheet-select">
                    <h5> Please select the file you want to update</h5>
                    <select
                        onChange={this.onfileSelected}
                        value={this.state.toUpdate}>
                        <option value="" selected disabled hidden>Choose here</option>                     
                        <option key={'sitemap'} value={'sitemap'}>Sitemap</option>
                        <option key={'metaTags'} value={'metaTags'}>Meta Tags</option>  
                    </select>
                </div>
                    <div className="spreadsheet-button">
                        <Button
                        text={'Update'}
                        size={5}
                        color={3}
                        onClick={this.onsubmit}
                        buttonFlat={true}
                        />
                    </div>
                </div>
                </div>
                <Footer />
                </div>
            )
        } else {
            return (
                <div>
                <p> Redirecting. <span style={{ textDecoration: "underline", cursor: "pointer", color: 'blue' }} onClick={() => {window.location.href = "/"}}> Click here </span> if this does not happen automatically</p>
                </div>
            )
        }
    }
}